import { DOMOutputSpec, NodeSpec, Node as ProsemirrorNode } from "prosemirror-model";
import { createStyleAttributeHandlers, StyleAttributes } from "./attributes/styleAttributes";

const stylesToCopy = {
	"border": "border",
	"borderCollapse": "border-collapse",
	"borderSpacing": "border-spacing",
	"display": "display"
} as const;

type TableRowStyleKeysToCopy = keyof typeof stylesToCopy;

export type TableRowNodeAttributes = StyleAttributes<TableRowStyleKeysToCopy>;
const {
	getStyleAttributes,
	setStyleAttributes,
	styleAttributeDefinitions
} = createStyleAttributeHandlers(stylesToCopy);

export const table_row: NodeSpec = {
	attrs: {
		...styleAttributeDefinitions
	},
	content: "(table_cell | table_header)*",
	tableRole: "row",
	parseDOM: [{
		tag: "tr",
		getAttrs(node: Node | string): TableRowNodeAttributes | false {
			if (!(node instanceof HTMLTableRowElement)) {
				throw new Error("Expected HTMLTableRowElement at this point");
			}

			const styleAttributes: StyleAttributes<TableRowStyleKeysToCopy> = getStyleAttributes(node);

			return {
				...styleAttributes
			};
		},
	}],
	toDOM(node: ProsemirrorNode): DOMOutputSpec {
		const styleValue: string | undefined = setStyleAttributes(node.attrs as TableRowNodeAttributes);
		return [
			"tr",
			{
				style: styleValue
			},
			0
		];
	},
};